import React from "react";
import "./Pricing.css";
const PricingPage = () => {
  const plans = [
    {
      name: "Starter",
      price: "₹499",
      features: ["1 Account", "Basic Transfers", "Email Support"],
    },
    {
      name: "Professional",
      price: "₹1299",
      features: ["5 Accounts", "Priority Transfers", "24/7 Support"],
      popular: true,
    },
    {
      name: "Enterprise",
      price: "₹2999",
      features: ["Unlimited Accounts", "Instant Transfers", "Dedicated Manager"],
    },
  ];
  return (
    <div className="pricing-page">
      <h2 className="title">Pricing Plans</h2>
      <p className="subtitle">Choose a plan that works for you</p>
      <div className="pricing-container">
        {plans.map((plan, index) => (
          <div key={index} className={`plan ${plan.popular ? "popular" : ""}`}>
            {plan.popular && <span className="badge">Most Popular</span>}
            <h3>{plan.name}</h3>
            <p className="price">{plan.price}<span>/mo</span></p>
            <ul>
              {plan.features.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
            <button className="choose-btn">Choose Plan</button>
          </div>
        ))}
      </div>
    </div>
  );
};
export default PricingPage;
